// Configuración de entorno
// Declaración de tipos para process.env (React Scripts lo proporciona en runtime)
declare const process: {
  env: {
    NODE_ENV?: string;
    REACT_APP_API_BASE_URL?: string;
  };
};

declare global {
  interface Window {
    __ENV__?: { API_BASE_URL?: string };
  }
}

const getApiBaseUrl = (): string => {
  // Prioridad 0: override en runtime (index.html o config inyectado) — útil cuando el dominio sirve SPA estático
  if (typeof window !== 'undefined' && window.__ENV__?.API_BASE_URL) {
    return window.__ENV__.API_BASE_URL;
  }
  // Prioridad 1: REACT_APP_API_BASE_URL (variable de entorno en build)
  const apiUrl = typeof process !== 'undefined' && process.env?.REACT_APP_API_BASE_URL
    ? process.env.REACT_APP_API_BASE_URL
    : null;
  if (apiUrl) {
    return apiUrl;
  }
  
  // Prioridad 2: Detectar automáticamente basándose en window.location
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;
    const origin = window.location.origin;
    
    // Si estamos en localhost, usar localhost:8000
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '') {
      return 'http://localhost:8000';
    }
    
    // Dominio personalizado: apuntar al backend en Heroku (evita 404 cuando el dominio solo sirve el SPA)
    if (hostname.includes('mihuellitadigital.com')) {
      // Dev/staging: subdominios dev. o staging. → backend dev (Heroku dev)
      if (hostname.startsWith('dev.') || hostname.startsWith('staging.')) {
        return 'https://mihuellitadigital-dev-13c5143db072.herokuapp.com';
      }
      // Prod: mihuellitadigital.com (o www.) → backend prod (Heroku prod)
      return 'https://sistema-veterinario-1757815595-7232578663c4.herokuapp.com';
    }
    
    // Si estamos en Heroku, usar la misma URL (el backend está en la misma app)
    if (hostname.includes('herokuapp.com')) {
      return origin;
    }
    
    // Si estamos en cualquier otro dominio, usar la misma URL (asumiendo que el backend está en el mismo dominio)
    return origin;
  }
  
  // Prioridad 3: Detectar por NODE_ENV
  const nodeEnv = typeof process !== 'undefined' ? process.env?.NODE_ENV : undefined;
  const isNodeDev = nodeEnv === 'development' || !nodeEnv;
  
  if (isNodeDev) {
    return 'http://localhost:8000';
  }
  
  // Fallback: URL de producción
  return 'https://sistema-veterinario-1757815595-7232578663c4.herokuapp.com';
};

export const ENV_CONFIG = {
  // URL del backend - cambiar según el entorno
  API_BASE_URL: getApiBaseUrl(),
  
  // Configuraciones adicionales
  APP_NAME: 'Mi Huellita Digital',
  VERSION: '1.0.0'
};
